import React, { Component } from 'react';

import { connect } from 'react-redux';

import { Button, Col, Row } from "react-bootstrap";

import ProductSelectedInfo from 'components/ProductSelectedInfo/ProductSelectedInfo';
import PaymentPlanTable from 'components/PaymentPlanTable/PaymentPlanTable';
import SaleProjection from 'components/SaleProjection/SaleProjection';
import Auth from "auth/Auth";

import history from 'routes/History/history';

import { showSuccessfulMessage } from 'reducers/application/applicationActions';

class SummaryStep extends Component {

    user;
    auth;
    constructor(props) {
        super(props);
        this.auth = new Auth();
        this.user = this.auth.getUser();
    }

    componentDidMount() {
        this.props.showSuccessfulMessage(this.props.customer ?
            "Afiliación realizada exitosamente" :
            "Venta realizada exitosamente");
    }

    goToSales() {
        history.push("sales");
    }

    render() {
        return (
            <div className="wizard-step">
                <Row className="justify-content-end wizard-buttons">
                    <Button className="bg-light-secondary"
                        onClick={() => this.goToSales()}>
                        Ir a Afiliaciones
                    </Button>
                </Row>

                <div className="row text-center">
                    <div className="offset-md-1 col-md-10">
                        <h1 className="text-success text-center">{this.props.customer ?
                            "Afiliación realizada exitosamente" :
                            "Venta realizada exitosamente"} </h1>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xl-5 no-padding">

                        <div className="col-md-12 sales__heading ">
                            <h5 className="">Resumen</h5>
                            <div className="wizard-inner-form-padding">
                                {this.props.product != null &&
                                    <ProductSelectedInfo product={this.props.product} />
                                }
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="wizard-inner-form-padding">
                                <b>Cliente: </b> &nbsp; {this.props.customer ? this.props.customer.completeName : this.user.completeName}
                            </div>
                            <div className="wizard-inner-form-padding">
                                <b>Venta al: </b> &nbsp; {this.props.paymentCondition.value === 'CREDIT' ? <span>Plazo</span> : <span>Contado</span>}
                            </div>
                        </div>

                    </div>

                    <div className="col-xl-7 no-padding">

                        <div className="col-md-12 sales__heading">
                            <h5>Proyección</h5>
                            <div className="wizard-inner-form-padding">
                                <SaleProjection
                                    negotiation={this.props.saleOrder} />
                            </div>
                        </div>

                        <div className="col-md-12 sales__heading">
                            <h5>Plan de Pagos</h5>
                            <div className="wizard-inner-form-padding">

                                <PaymentPlanTable
                                    quotas={this.props.saleOrder.quotaList}
                                />

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

const mapStateToProps = state => ({
    paymentCondition: state.saleorder.paymentCondition,
    product: state.saleorder.product,
    customer: state.saleorder.customer,
    saleOrder: state.saleorder.saleOrder
});

export default connect(
    mapStateToProps,
    { showSuccessfulMessage },
    null,
    { withRef: true }
)(SummaryStep);


// WEBPACK FOOTER //
// ./src/components/SalesWizard/Steps/SummaryStep.jsx